import { z } from 'zod';
import { IsoTimestamp } from './common';

export const DeletionTombstone = z.object({
  userId: z.string(),
  deletedByEmail: z.string().email(),
  deletedByUserId: z.string(),
  deletedAt: IsoTimestamp,
  requestSource: z.enum(['user', 'admin']),
  retentionExpiresAt: IsoTimestamp,
});
export type DeletionTombstone = z.infer<typeof DeletionTombstone>;
